import React, { useState, useEffect } from 'react';

import axios from 'axios';
import {CarouselProvider, DotGroup, Slide, Slider} from "pure-react-carousel";
import moment from "moment";
import {default as UCI} from "../uci_points_hierarchy";
import {default as renderDots} from './Pagination';
import 'pure-react-carousel/dist/react-carousel.es.css';
import {filterAthletes} from "../helper";

function OverallLeaderboard (props) {

    const [leaderboard, setLeaderboard] = useState({entries: []});

    const [duplicates, setDuplicates] = useState([]);

    const [slides, setSlides] = useState([]);

    const perPage = 25;

    useEffect(() => {

        axios.get(`/api/leaderboard?gender=${props.gender}`)
            .then(result => {

                setDuplicates(JSON.parse(result.headers.duplicates));

                setLeaderboard(result.data);

                return result;


            })
            .catch(error => console.log(error));

    }, []);

    useEffect(() => {

        const filtered = leaderboard.entries.filter((entry) => filterAthletes(entry, props.searchString));

        const s = [];

        for(let i = 0; i < filtered.length/perPage; i++) {

            s.push(i);

        }

        setSlides(s);

    }, [props.searchString, leaderboard]);


    return (
        <div>
            <div className="d-flex align-items-center">
                <h3 className={'mr-3'}>{props.gender === 'M' ? 'Buaba' : 'Mädla'}</h3>
                <span className={'mr-auto'}>{leaderboard.entry_count} gesamt</span>
            </div>

            <table className={'table mb-0'}>

                <thead>
                <tr>
                    <th className={'w-12'}>Platz</th>
                    <th className={'w-75'}>Name</th>
                    <th className={'w-25'}>Punkte</th>
                </tr>
                </thead>
            </table>

            <CarouselProvider
                naturalSlideWidth={100}
                naturalSlideHeight={200}
                totalSlides={slides.length}
                isIntrinsicHeight={true}
            >
                <Slider>

                    {slides.map((slide, i) => <Slide index={i} key={i}>
                        <table className={'table'}>

                            <thead style={{visibility: 'collapse', maxHeight: '0px'}}>
                            <tr>
                                <th className={'w-12'}>Platz</th>
                                <th className={'w-75'}>Name</th>
                                <th className={'w-25'}>Punkte</th>
                            </tr>
                            </thead>

                            <tbody>
                            {leaderboard.entries.filter((entry) => filterAthletes(entry, props.searchString)).slice(slide*perPage, (slide+1)*perPage).map((entry, i) => (
                                <tr key={i}>
                                    <td>{entry.rank}</td>
                                    <td>{entry.athlete_name}</td>
                                    <td>{entry.points}</td>
                                </tr>

                            ))}
                            </tbody>
                        </table>
                    </Slide>)}
                </Slider>

                <DotGroup renderDots={renderDots}></DotGroup>

            </CarouselProvider>

            {duplicates.length > 0 && <div className="alert alert-primary alert-dismissible fade show" role="alert">
                <strong>Haidabimbam!</strong> Wegen Namensdopplung werden die Punkte für {duplicates.map((name, i) => <span key={i}>{(i === duplicates.length-1 && i > 0) && ' und'} {name}{(i < duplicates.length-1 && duplicates.length > 2) && ', '}</span>)} vorübergehend nicht richtig zusammengezählt.
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>}

        </div>
    );
}

export default OverallLeaderboard;
